<template>
  <span :class="'grid-badge badge ' + badgeClass">{{ text }}</span>
</template>

<style lang="scss">
@import "badgeComponent.scss";
</style>

<script type="text/javascript">
import Vue from "vue";
export default Vue.extend({
  props: {
    text: {
      type: String,
      default: ""
    },
    badgeClass: {
      type: String,
      default: "badge-success"
    }
  },

  data() {
    return {};
  },

  methods: {}
});
</script>
